import { useState, useRef, useCallback } from "react";
import { useConfig } from "../config/ConfigProvider";

export const useSpeechToText = () => {
    const config = useConfig();
    const [isListening, setIsListening] = useState(false);
    const [transcript, setTranscript] = useState<string>("");
    const recognitionRef = useRef<SpeechRecognition | null>(null);
    const timeoutRef = useRef<any>(null);

    const resetTimer = useCallback(() => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            recognitionRef.current?.stop();
        }, 2000);
    }, []);

    const startListening = useCallback(() => {
        if (!("SpeechRecognition" in window || "webkitSpeechRecognition" in window)) {
            throw new Error("Speech recognition not supported in this browser");
        }

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();
        recognitionRef.current = recognition;

        recognition.lang = config.ui?.speech_to_text_language || "en-US";
        recognition.continuous = true;
        recognition.interimResults = true;

        recognition.onresult = (event: SpeechRecognitionEvent) => {
            resetTimer();

            const fullTranscript = Array.from(event.results)
                .map((result) => result[0])
                .map((result) => result.transcript)
                .join(" ");

            setTranscript(fullTranscript);
        };

        recognition.onerror = (event) => {
            console.error("Speech recognition error:", event);
        };

        recognition.onend = () => {
            setIsListening(false);
            console.log("Speech recognition ended");
        };

        recognition.start();
        resetTimer();
        setIsListening(true);
    }, [resetTimer]);

    const stopListening = useCallback(() => {
        recognitionRef.current?.stop();
        setIsListening(false);
        clearTimeout(timeoutRef.current);
    }, []);

    return {
        isListening,
        transcript,
        startListening,
        stopListening,
    };
};


// export const speechToText = async (options?: {
//     onTranscriptUpdate: (partialTranscript: string) => void
// }): Promise<string> => {

//     if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
//         const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//         const recognition = new SpeechRecognition();

//         recognition.lang = "en-US";
//         recognition.continuous = true;
//         recognition.interimResults = true;

//         const resetTimer = () => {
//             clearTimeout(timeout);
//             timeout = setTimeout(() => {
//                 recognition.stop();
//             }, 2000);
//         }

//         let fullTranscript = "";

//         return new Promise((resolve, reject) => {
//             recognition.onresult = (event: SpeechRecognitionEvent) => {
//                 resetTimer();

//                 fullTranscript = Array.from(event.results)
//                     .map((result) => result[0])
//                     .map((result) => result.transcript)
//                     .join(" ");

//                 if (options?.onTranscriptUpdate) {
//                     options.onTranscriptUpdate(fullTranscript);
//                 }
//             };

//             recognition.onerror = (event) => {
//                 console.error("Speech recognition error:", event);
//                 reject(new Error("Speech recognition error"));
//             };

//             recognition.onend = () => {
//                 console.log("Speech recognition ended");
//                 resolve(fullTranscript.trim());
//             };

//             recognition.start();
//             resetTimer();
//         });
//     } else {
//         throw new Error("Speech recognition not supported in this browser");
//     }
// };